// @flow
import React, { type Node } from 'react';

import ControlsBar from 'app/common/ui-next/controls-bar';
import PlainButton from 'app/common/ui-next/plain-button';


type Props = {
  children: Node,
  cancelButtonText: string,
  onCancel: () => void,
}

const OrderFooter = ({ children, cancelButtonText, onCancel }: Props): Node => {
  return (
    <ControlsBar spaceBetween>
      <ControlsBar right>
        <PlainButton onClick={onCancel} outline>
          {cancelButtonText}
        </PlainButton>
      </ControlsBar>

      {children}
    </ControlsBar>
  );
};

export default OrderFooter;
